<template>
    <div
        class="gift-card"
        :style="{
            backgroundColor: rgbaValue(background_color)
        }"
    >
        <div
            class="d-flex justify-space-between gift-card__header"
            :style="{
                color: rgbaValue(text_color)
            }"
        >
            <div class="d-flex align-center">
                <div>
                    <v-img :src="logo" class="gift-card__logo" />
                </div>
                <div class="gift-card__business-name">
                    {{ business_name }}
                </div>
            </div>
            <div class="gift-card__balance">
                {{ $t("balance") }}:
                <div class="gift-card__balance__price">
                    {{ currency_symbol
                    }}{{ price ? addDecimal(price) : addDecimal(0.0) }}
                </div>
            </div>
        </div>

        <div
            :class="[
                'gift-card__cover d-flex justify-center align-end flex-column',
                background_image ? 'gift-card__cover--image' : ''
            ]"
            :style="{
                backgroundImage:
                    'url(' + (background_image ? background_image : '') + ')',
                color: rgbaValue(cover_text_color),
                backgroundColor: background_image
                    ? ''
                    : rgbaValue(cover_background_color)
            }"
        >
            <div class="gift-card__cover__nickname">
                {{ card_name }}
            </div>
            <div>{{ $t("card") }} {{ card_number.match(/\d{4}$/)[0] }}</div>
        </div>

        <div
            class="gift-card__content text-center"
            :style="{
                color: rgbaValue(text_color)
            }"
        >
            <div class="">
                <v-img
                    :src="qr_image"
                    class="gift-card__qr_placeholder  mx-auto"
                />

                <div class="gift-card__content__number">
                    {{ card_number }}
                </div>
            </div>
        </div>

        <div
            class="gift-card__footer d-flex flex-col align-center"
            :style="{
                color: rgbaValue(text_color)
            }"
        >
            <div>
                <v-img :src="logo" class="gift-card__footer__logo" />
            </div>
            <div>
                {{ address }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        "business_name",
        "address",
        "logo",
        "background_color",
        "text_color",
        "cover_text_color",
        "cover_background_color",
        "business",
        "background_image",
        "price",
        "qr_image",
        "card_number",
        "card_name",
        "currency_symbol"
    ],
    data() {
        return {};
    },
    methods: {
        rgbaValue(color) {
            if (color.rgba) {
                const { r, g, b, a } = color.rgba;
                return `rgba(${r}, ${g}, ${b}, ${a})`;
            }
            return color;
        },
        addDecimal(price) {
            const parsedPrice = parseFloat(price);
            const formattedPrice = parsedPrice.toFixed(2);
            return formattedPrice;
        }
    }
};
</script>

<style>
.gift-card {
    width: 100%;
    height: 1016px;
    border: solid 1px rgba(0, 0, 0, 0.42);
    font-weight: 600;
    display: flex;
    flex-direction: column;
}
.gift-card__header {
    padding: 25px;
}
.gift-card__logo {
    width: 80px;
    height: 80px;
}
.gift-card__business-name {
    font-size: 22px;
    margin-left: 8px;
}
.gift-card__balance {
    font-size: 21px;
    text-align: right;
}
.gift-card__balance__price {
    text-align: right;
    margin-top: 6px;
}
.gift-card__cover {
    height: 250px;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    z-index: 0;
    font-size: 36px;
    padding: 10px 25px;
    background-position: center;
}
.gift-card__cover:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
}
.gift-card__cover--image:after {
    background: rgba(255, 255, 255, 0.5);
}
.gift-card__cover__nickname {
    margin-bottom: 30px;
}
.gift-card__content {
    padding: 40px 25px 25px 25px;
    font-size: 36px;
    flex: 1;
}
.gift-card__content__number {
    margin-top: 15px;
}
.gift-card__qr_placeholder {
    width: 170px;
    height: 170px;
}
.gift-card__footer {
    padding: 10px 10px;
    font-size: 20px;
}
.gift-card__footer__logo {
    width: 60px;
    height: 60px;
    margin-right: 10px;
}
.card-design {
    position: relative;
    width: 377px;
    height: 220px;
    /* background: url("../../assets/default_wood.jpg") no-repeat; */
    color: #ffffff;
}
.card-design .card-box {
    position: absolute;
    left: 20px;
    right: 20px;
    top: 20px;
    text-shadow: 0 1px 10px rgba(0, 0, 0, 0.2);
}
.card-design .title {
    font-size: 22px;
    font-weight: 700;
}
.card-design .description {
    padding-top: 15px;
    font-size: 14px;
    font-weight: 400;
}
</style>
